import { api } from "@/modules/help-center/services";
import { INaicsCodeItem } from "@/modules/help-center";

export const getNaicsCodes = async () => {
  const codes: INaicsCodeItem[] | null = await api.getNaicsCodes();
  return codes || [];
};
